import { ICellRendererParams } from '@ag-grid-community/core'
import { generateMdiIcon } from '@helios/ag-grid-config'

export const usersInAccountCellRenderer = (
  params: ICellRendererParams,
  currentUser?: string,
) => {
  const usernames: string[] = params.value ?? []

  // If the current user is in the list of users, then
  // show an editing icon.
  // https://jira.arbfund.com/browse/PVAL-7885
  if (currentUser && usernames.includes(currentUser)) {
    return generateMdiIcon('mdi-account-edit')
  } else if (usernames.length === 1) {
    return generateMdiIcon('mdi-account')
  } else if (usernames.length === 2) {
    return generateMdiIcon('mdi-account-multiple')
  } else if (usernames.length >= 3) {
    return generateMdiIcon('mdi-account-group')
  } else {
    return ''
  }
}
